<template>
    <b-row>
        <b-col cols="12" class="pt-3">
            <ContentOrLoading>
                <b-table
                    v-if="entradasCompradas.data"
                    striped
                    hover
                    :items="entradasCompradas.data"
                    :fields="[
                        { key: 'nombre_evento', label: 'Nombre' },
                        { key: 'asunto', label: 'Asunto del evento' },
                        { key: 'total_entradas', label: 'Total entradas' },
                        { key: 'fecha_evento', label: 'Fecha evento' },
                    ]"
                    :busy="loading"
                    show-empty
                >
                    <template #empty>
                        <h4 class="text-center">No hay ningún resultado</h4>
                    </template>
                    <template #cell(nombre_evento)="data">
                        {{ data.item.nombre_evento }}
                    </template>
                    <template #cell(asunto)="data">
                        {{ data.item.comunicado.asunto }}
                    </template>
                    <template #cell(total_entradas)="data">
                        {{ data.item.total_entradas }}
                    </template>
                    <template #cell(fecha_evento)="data">
                        {{ data.item.fecha }}
                    </template>
                </b-table>
                <b-pagination
                    v-if="entradasCompradas.meta"
                    v-model="entradasCompradas.meta.current_page"
                    :total-rows="entradasCompradas.meta.total"
                    :per-page="entradasCompradas.meta.per_page"
                    @page-click="pageClicked"
                />
            </ContentOrLoading>
        </b-col>
    </b-row>
</template>
<script>
    import apiService from '@/services/api-comunicados';

    export default {
        name: 'SubscriptorEntradasCompradas',
        props: {
            subscriptor: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                entradasCompradas: {}
            };
        },
        methods: {
            getEntradasCompradas(page = 1) {
                const filters = {
                    per_page: 10,                  
                    page: page,
                    sortBy: 'total_entradas',
                    order: 'desc'
                }
                try {
                    this.loading = true;
                    apiService.getEntradasCompradas(this.subscriptor.id, filters).then(response => {
                        this.entradasCompradas = response;
                    }).catch(error => {
                        console.error("Error fetching entradas compradas:", error);
                    }).finally(() => {
                        this.loading = false;
                    });
                } catch (error) {
                    console.error("Error in getEntradasCompradas method:", error);
                }
            },
            pageClicked(event, page) {
                this.getEntradasCompradas(page);
            }
        },
        mounted() {
            this.getEntradasCompradas();
        }
    }
</script>